export default __webpack_public_path__ + "static/media/kaggle.c4cd9d8b.png";